<template>
    <div class="wrapper">
        <div class="bar">
            <div class="btnGroup">
                <el-button class="btn" @click="addOrder">添加订单</el-button>
                <el-button class="btn" @click="ShowInputOrder = true">导入订单</el-button>
                <span style="margin-left: 50px">订单来源　</span>
                <el-select v-model="ddly" placeholder="请选择" style="width: 100px">
                    <el-option
                        v-for="item in ddlySelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <span style="margin-left: 50px">配送方式　</span>
                <el-select v-model="psfs" placeholder="请选择" style="width: 100px">
                    <el-option
                        v-for="item in psfsSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>

                <span style="margin-left: 50px">订单状态　</span>
                <el-select v-model="ddzt" placeholder="请选择" style="width: 100px">
                    <el-option
                        v-for="item in ddztSelect"
                        :key="item.referer"
                        :label="item.name"
                        :value="item.referer">
                    </el-option>
                </el-select>
                <el-button class="btn" @click="searchOrder" style="margin-left: 20px">搜索</el-button>
            </div>
        </div>
        <el-table
            :data="orderList"
            style="width: 100%"
            >
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="props">
                    <el-button style="padding: 7px 15px;background:#5bc377; border-radius: 5px;font-size: 12px;color: white" @click="OrderAdd(props.row)" v-show="props.row.install_state==='0'||props.row.install_state==='1'">分配订单</el-button>
                    <el-button type="text" size="small" @click="CloseOrder(props.row)" v-show="props.row.is_yuyue===0&props.row.tax === '0'">关闭</el-button>
                    <el-button type="text" size="small" @click="QrOrder(props.row)" v-show="props.row.is_yuyue===0&props.row.tax === '1'">取消关闭</el-button>
                    <!--<el-button style="padding: 7px 15px;background:#f56c31; border-radius: 5px;font-size: 12px;color: white" @click="OrderAnpai(props.row)" v-show="props.row.is_yuyue===0&&props.row.install.status==='8'" >订单安排</el-button>-->
                    <a style="" @click="OrderDetail(props.row)"  v-show="props.row.is_yuyue===1" >查看详情</a>
                </template>
            </el-table-column>
            <el-table-column label="订单来源" prop="xiadanname" width="150"> </el-table-column>
            <el-table-column label="订单号" width="100" align="center">
                <template slot-scope="props">
                    <div  style="font-size: 10px;" :style="props.row.referer ==='管理员添加'?{color:'red'}:''">{{props.row.referer !=='管理员添加'?props.row.order_sn:'只安装'}}</div>
                </template>
            </el-table-column>
            <el-table-column label="合同订单号" prop="contract_number" width="100" align="center"></el-table-column>
            <el-table-column label="型号" width="120" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods_list" style="font-size: 10px;">{{item.goods_attr_select.length ===0?item.goods_attr:item.goods_attr_select[0]}}</div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="50" align="center">
                <template slot-scope="props">
                    <div v-for="item in props.row.goods_list">{{item.goods_number}}</div>
                </template>
            </el-table-column>
            <el-table-column label="客户姓名" prop="consignee" align="center" width="70"></el-table-column>
            <el-table-column label="客户电话" prop="mobile" align="center"></el-table-column>
            <!--<el-table-column label="备用电话" prop="tel" align="center"></el-table-column>-->
            <el-table-column label="客户地址" prop="address_detail" align="center" width="180"></el-table-column>
            <el-table-column label="备注" prop="postscript" align="center" ></el-table-column>
            <el-table-column label="配送方式"  align="center" width="80">
                <template slot-scope="props">
                    <div :style="props.row.install.delivery_method === '0'?{color:'orange'}:props.row.install.delivery_method === '1'?{color:'green'}:props.row.install.delivery_method === '2'?{color:'blue'}:props.row.install.delivery_method === '3'?{color:'#6483ff'}:props.row.install.delivery_method === '4'?{color:'black'}:props.row.install.delivery_method === '10'?{color:'red'}:props.row.install.delivery_method === '5'?{color:'pink'}:props.row.install.delivery_method === '6'?{color:'#666'}:props.row.install.delivery_method === '11'?{color:'black'}:''">
                        {{props.row.install.delivery_method === '0'&&props.row.install.status !=='8'?'送货':props.row.install.delivery_method === '1'?'物流':props.row.install.delivery_method === '2'?'自提':props.row.install.delivery_method === '3'?'送装':props.row.install.delivery_method === '4'?'快递':props.row.install.delivery_method === '5'?'直发':props.row.install.delivery_method === '6'?'其他':props.row.install.delivery_method === '9'?'铺管':props.row.install.delivery_method === '10'?'只安装':props.row.install.delivery_method === '11'?'占库存':''}}
                    </div>
                </template>
            </el-table-column>
            <!--<el-table-column label="配送方式" prop="address" align="center"></el-table-column>-->
            <el-table-column label="订单状态"   align="center" width="80" >
                <template slot-scope="props">
                    <div style="color: white;height: 50px;line-height:50px;margin: 0;padding: 0; font-size: 12px;" :style="props.row.install.type=='未分配'?{color:'#595a5c'}:props.row.install.type=='部分分配'?{color:'#6bbef1'}:props.row.install.type=='已预约'?{color:'#f56c31'}:{color:'#5bc377'}">
                        {{props.row.install.type}}
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="currPage"
            :page-count="totalPage"
            :getOrderList="getOrderList"
            @current-change="handlePageChange"
        >
        </el-pagination>
        <el-dialog title="订单分配" :visible.sync="ShowDistribution" width="1100px">
            <div class="dialog-left">
                <el-table
                    ref="multipleTable"
                    :data="OrderFenpei"
                    tooltip-effect="dark"
                    style="width: 100%;font-size: 12px;"
                    @selection-change="handleSelectionChange">
                    <el-table-column
                        type="selection"
                        width="30">
                    </el-table-column>
                    <el-table-column label="全选" width="60"></el-table-column>
                    <el-table-column label="商品型号" align="center">
                        <template slot-scope="props">
                            {{props.row.goods_attr_select.length ===0?props.row.goods_attr:props.row.goods_attr_select[0]}}
                        </template>
                    </el-table-column>
                    <el-table-column label="购买" prop="goods_number" align="center"></el-table-column>
                    <el-table-column label="已分配" prop="yuyue_number" align="center"></el-table-column>
                    <el-table-column label="可用数量" prop="keyongNum" align="center"></el-table-column>
                    <el-table-column label="分配"  align="center">
                        <template slot-scope="props">
                            <el-input-number v-model="props.row.fpnum" controls-position="right" :min="1" :max="props.row.keyongNum<=(props.row.goods_number-props.row.yuyue_number)&&props.row.referer!=='k3导入'&&props.row.referer!=='管理员添加'?props.row.keyongNum:props.row.goods_number-props.row.yuyue_number" @change="handleChange"  size="small" style="width: 80px"></el-input-number>
                            <!--{{props.row.goods_number-props.row.yuyue_number}}-->
                        </template>
                    </el-table-column>
                    <el-table-column label="允许负库存"   align="center">
                        <template slot-scope="props">
                            <el-checkbox v-model="props.row.relateCan"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="dialog-right">
                <el-form :model="form">
                    <el-form-item label="客户姓名:" :label-width="formLabelWidth">
                        <el-input v-model="form.consignee" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" :label-width="formLabelWidth">
                        <el-input v-model="form.mobile" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备用电话:" :label-width="formLabelWidth">
                        <el-input v-model="form.tel" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="送货方式:" :label-width="formLabelWidth">
                        <el-select v-model="formData.goodsSelect" :disabled="ispuguan" placeholder="请选择送货方式" style="width: 290px" @change="isSongZhuang">
                            <el-option
                                v-for="item in passSelect"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="formData.goodsSelect===0?'送货时间':formData.goodsSelect===1?'物流时间':formData.goodsSelect===2?'自提时间':formData.goodsSelect===3?'送装时间':formData.goodsSelect===10?'安装时间':formData.goodsSelect===4?'快递时间':formData.goodsSelect===9?'时间':'其他'" :label-width="formLabelWidth" v-show="formData.goodsSelect===3||formData.goodsSelect===0||formData.goodsSelect===1||formData.goodsSelect===2||formData.goodsSelect===4||formData.goodsSelect===6||formData.goodsSelect===9||formData.goodsSelect===10">
                        <el-date-picker
                            v-model="formData.azTime"
                            @change="consl"
                            type="date"
                            placeholder="选择时间"
                            :picker-options="pickerOptions0" style="width: 290px"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="安装公司:" :label-width="formLabelWidth" v-show="(formData.goodsSelect===3||formData.goodsSelect===9||formData.goodsSelect===10) ">
                        <el-select v-model="formData.company_id" placeholder="公司名称" @change="selectname(formData.company_id)" style="width: 290px" :disabled="ispuguan">
                            <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物流公司:" :label-width="formLabelWidth" v-show="formData.goodsSelect===1">
                        <el-select v-model="formData.wuliu_id" placeholder="物流公司名称" @change="selectwuliuu(formData.wuliu_id)" style="width: 290px">
                            <el-option v-for="item in selectWuliu" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="快递公司:" :label-width="formLabelWidth" v-show="formData.goodsSelect===4">
                        <el-select v-model="formData.kuaidi_id" placeholder="快递公司名称" @change="selectkuaidi(formData.kuaidi_id)" style="width: 290px">
                            <el-option v-for="item in selectKuaidi" :label="item.name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物流收费方式:" :label-width="formLabelWidth" v-show="formData.goodsSelect===1">
                        <el-select v-model="formData.wuliu_pay" placeholder="物流公司名称" style="width: 290px">
                            <el-option v-for="item in paySelect" :label="item.label" :value="item.value" :key="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="送货司机:" :label-width="formLabelWidth" v-show="formData.goodsSelect===0">
                        <el-select v-model="formData.siji_id" placeholder="送货司机名称" @change="selectsiji(formData.siji_id)" style="width: 290px">
                            <el-option v-for="item in selectSonghuo" :label="item.siji_name" :value="item.id" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="送货地址:" :label-width="formLabelWidth">
                        <div v-show="changeAddress == false"><span style="float: left">{{form.address_detail}}</span><el-button type="primary" @click="isChangeAddr" >修改地址</el-button></div>
                        <div v-if="changeAddress == true">
                            <el-select v-model="formData.province" placeholder="省份" style="width: 90px;">
                                <el-option
                                    v-for="{region_id, region_name} in provinceList"
                                    :key="region_id"
                                    :value="region_id"
                                    :label="region_name"
                                >
                                </el-option>
                            </el-select>
                            <el-select v-model="formData.city" placeholder="城市" style="width: 90px;">
                                <el-option
                                    v-for="{region_id, region_name} in cityList"
                                    :key="region_id"
                                    :value="region_id"
                                    :label="region_name"
                                ></el-option>
                            </el-select>
                            <el-select v-model="formData.district" placeholder="区" style="width: 90px;">
                                <el-option
                                    v-for="{region_id, region_name} in districtList"
                                    :key="region_id"
                                    :value="region_id"
                                    :label="region_name"
                                ></el-option>
                            </el-select>
                            <el-input :rows="3" type="textarea" placeholder="详细地址信息" v-model="formData.address" style="margin-top: 15px"></el-input>
                            <!--<a @click="SureChangeAddr">确认修改</a><a>　|　</a>-->
                            <a @click="FalseChangeAddr">取消修改</a>
                        </div>
                    </el-form-item>
                    <el-form-item label="备注:" :label-width="formLabelWidth">
                        <el-input v-model="formData.remark" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                    <el-button @click="ShowDistribution = false">取 消</el-button>
                    <el-button type="primary" @click="queren" :loading="isbtnload">提交</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="订单详情" :visible.sync="ShowDetail" width="800px">
            <div class="dialog-left">
                <el-table
                    ref="multipleTable"
                    :data="OrderFenpei"
                    tooltip-effect="dark"
                    style="width: 100%;font-size: 12px"
                    @selection-change="handleSelectionChange">
                    <el-table-column label="商品型号" align="center">
                        <template slot-scope="props">
                            {{props.row.goods_attr_select.length ===0?props.row.goods_attr:props.row.goods_attr_select[0]}}
                        </template>
                    </el-table-column>
                    <el-table-column label="购买" prop="goods_number" align="center"></el-table-column>
                    <el-table-column label="已分配" prop="yuyue_number" align="center"></el-table-column>
                </el-table>
            </div>
            <div class="dialog-right">
                <el-form :model="form">
                    <el-form-item label="客户姓名:" :label-width="formLabelWidth">
                        <span style="float: left">{{form.consignee}}</span>
                    </el-form-item>
                    <el-form-item label="联系电话:" :label-width="formLabelWidth">
                        <span style="float: left">{{form.mobile}}</span>
                    </el-form-item>
                    <el-form-item label="送货地址:" :label-width="formLabelWidth">
                        <div ><span style="float: left">{{form.address_detail}}</span></div>
                    </el-form-item>
                    <el-form-item label="备注:" :label-width="formLabelWidth">
                        <span style="float: left">{{form.remark}}</span>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                    <el-button @click="ShowDetail = false">关闭</el-button>
                    <!--<el-button type="primary" @click="queren">提交</el-button>-->
                </div>
            </div>

        </el-dialog>
        <el-dialog title="添加订单" :visible.sync="ShowAddOrder" width="800px">
                <el-form :model="addForm" :rules="rules" ref="ruleForm" inline="inline">
                    <el-form-item label="客户姓名:" :label-width="formLabelWidth" prop="consignee">
                        <el-input v-model="addForm.consignee" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话:" :label-width="formLabelWidth" prop="mobile">
                        <el-input v-model="addForm.mobile" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="备用电话:" :label-width="formLabelWidth" prop="tel">
                        <el-input v-model="addForm.tel" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="合同订单号:" :label-width="formLabelWidth" prop="contract_number">
                        <el-input v-model="addForm.contract_number" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="提货单号:" :label-width="formLabelWidth" prop="order_sn">
                        <el-input v-model="addForm.order_sn" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="业务员:" :label-width="formLabelWidth">
                        <el-input v-model="addForm.staff_name" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="部门:" :label-width="formLabelWidth">
                        <el-input v-model="addForm.store_name" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="经销商:" :label-width="formLabelWidth">
                        <el-select v-model="addForm.agency_id">
                            <el-option v-for="item in agencyList" :label="item.label" :value="item.value" :key="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="送货类型:" :label-width="formLabelWidth">
                        <el-radio v-model="addForm.method_type" label="10">只安装不送货</el-radio>
                        <el-radio v-model="addForm.method_type" label="3">送装</el-radio>
                    </el-form-item>
                </el-form>
                    <el-form :model="addForm" :rules="rules" ref="ruleForm">
                        <el-form-item label="商品:" :label-width="formLabelWidth">
                            <div v-for="(item,index) in goodsList">
                                <span>商品型号:</span>
                                <!--<el-input v-model="goodsList[index].goods" style="width: 150px"></el-input>-->
                                <el-autocomplete
                                    class="inline-input"
                                    @change="getShopAttr"
                                    v-model="goodsList[index].goods"
                                    :fetch-suggestions="querySearch2"
                                    placeholder="请输入型号"
                                    @select="handleSelect2"
                                ></el-autocomplete>
                                <span style="margin:0 20px;">商品数量:</span><el-input v-model="goodsList[index].number" style="width: 100px;margin: 10px 0;"></el-input>
                                <!--<span style="margin:0 20px">商品价格:</span><el-input v-model="goodsList[index].price" style="width: 100px;margin: 10px 0;"></el-input>-->
                                <el-button type="text" @click="delGoods(index)">删除</el-button>
                            </div>
                            <el-button type="text" @click="addGoods">添加商品</el-button>
                        </el-form-item>
                    <el-form-item label="送货地址:" :label-width="formLabelWidth">
                            <el-input :rows="3" type="textarea" placeholder="详细地址信息" v-model="formData.address" style="margin-top: 15px"></el-input>
                    </el-form-item>
                    <el-form-item label="备注:" :label-width="formLabelWidth">
                        <el-input v-model="addForm.postscript" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                    <el-button @click="ShowAddOrder = false">取 消</el-button>
                    <el-button type="primary" @click="qrAdd" :loading="isbtnload">提交</el-button>
                </div>
        </el-dialog>
        <el-dialog title="导入订单" :visible.sync="ShowInputOrder" width="500px">
            <el-form :model="inputForm" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="公司:" :label-width="formLabelWidth">
                    <el-select v-model="k3url" style="width: 100%;" class="select">
                        <el-option v-for="item in select" :label="item.label" :value="item.value" :key="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售订单号:" :label-width="formLabelWidth">
                    <el-input v-model="inputForm.DDDH"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button type="primary" @click="InpurtOrder" >确定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="订单安排" :visible.sync="ShowXiapai" width="500px">
            <el-form :model="yuyueForm" style="margin-top: 30px;padding: 0 30px">
                <el-form-item label="送货方式:" :label-width="formLabelWidth">
                    <el-select v-model="formData.goodsSelect" placeholder="请选择送货方式" style="width: 290px" @change="isSongZhuang">
                        <el-option
                            v-for="item in passSelect"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="安装公司:" :label-width="formLabelWidth" v-show="formData.goodsSelect===3||formData.goodsSelect===9||formData.goodsSelect===10">
                    <el-select v-model="formData.company_id" placeholder="公司名称" @change="selectname(formData.company_id)" style="width: 290px">
                        <el-option v-for="item in selectCompany" :label="item.company_name" :value="item.company_id" :key="item.company_id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流公司:" :label-width="formLabelWidth" v-show="formData.goodsSelect===1">
                    <el-select v-model="formData.wuliu_id" placeholder="物流公司名称" @change="selectwuliuu(formData.wuliu_id)" style="width: 290px">
                        <el-option v-for="item in selectWuliu" :label="item.name" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="物流收费方式:" :label-width="formLabelWidth" v-show="formData.goodsSelect===1">
                    <el-select v-model="formData.wuliu_pay" placeholder="物流公司名称" style="width: 290px">
                        <el-option v-for="item in paySelect" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="送货司机:" :label-width="formLabelWidth" v-show="formData.goodsSelect===0">
                    <el-select v-model="formData.siji_id" placeholder="送货司机名称" @change="selectsiji(formData.siji_id)" style="width: 290px">
                        <el-option v-for="item in selectSonghuo" :label="item.siji_name" :value="item.id" :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="padding: 20px 0">
                <el-button type="primary" @click="OrderYuyue">确定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
    import {getInstallCompany, getAddressSelect, postAppointment, session_id} from "../../stores/api";
    import qs from 'qs'
    import { mapState } from 'vuex';
    export default {
        props: ['orderList', 'totalPage', 'getOrderList', 'currPage', 'ddly', 'psfs', 'ddzt'],
        data() {
            return {
                relateCan: [],
                loading: true,
                fpload: true,
                isbtnload: false,
                tableData: [],
                ShowDistribution: false,
                ShowAddOrder: false, //是否显示添加订单弹框
                ShowXiapai: false, //预约安装弹出框
                ShowInputOrder: false,
                inputForm: {
                   DDDH: '',
                },
                goodsList: [{
                    goods: '',
                    number: '',
                    price: '',

                }], //商品属性
                select: [{label: '亿星', value: 'http://gzyxkingdee.gnway.org:8008/GZYXSC/service.asmx?wsdl'}, {label: '艾巢', value: 'http://gzyxkingdee.gnway.org:8008/acsc/service.asmx?wsdl'}],
                k3url: 'http://gzyxkingdee.gnway.org:8008/GZYXSC/service.asmx?wsdl',
                ddlySelect: [{name: '全部', referer: ''}, {name: 'k3导入', referer: 'k3导入'}, {name: '新增', referer: '管理员添加'}, {name: 'PC商城', referer: 'PC'}, {name: '供应链', referer: '供应链'}, {name: '门店', referer: '门店'}, {name: '扫码', referer: '扫码'}],
                ddly: '',
                psfsSelect: [{name: '全部', referer: ''}, {name: '送货', referer: 0}, {name: '物流', referer: 1}, {name: '自提', referer: 2}, {name: '送装', referer: 3}, {name: '快递', referer: 4}, {name: '直发', referer: 5}, {name: '铺管', referer: 9}, {name: '其他', referer: 6}],
                psfs: '',
                ddztSelect: [{name: '全部', referer: '0,1,2'}, {name: '可分配', referer: '0,1'}, {name: '已分配', referer: '2'}, {name: '未分配', referer: '0'}, {name: '部分分配', referer: '1'}, {name: '已关闭', referer: '4'}],
                ddzt: '',
                ShowDetail: false,
                OrderFenpei: [],
                OrderSelect: [], //分配的订单数组
                formLabelWidth: '100px',
                form: {},
                changeAddress: false, //是否修改地址
                paySelect: [{value: '01', label: '发货方付'}, {value: '02', label: '到付'}],
                passSelect: [{value: 0, label: '送货'},
                    {value: 1, label: '物流'},
                    {value: 2, label: '自提'},
                    {value: 3, label: '送装'},
                    {value: 10, label: '只安装'},
                    {value: 9, label: '铺管'},
                    {value: 11, label: '占用库存'},
                    {value: 4, label: '快递'},
                    {value: 5, label: '直发'},
                    {value: 6, label: '其他'},

                ],
                rules: {
                    consignee: [{required: true, message: '请输入客户姓名', trigger: 'blur'}],
                    mobile: [{required: true, message: '请输入电话', trigger: 'blur'}],
                    contract_number: [{required: true, message: '请输入合同订单号', trigger: 'blur'}],
                },
                addForm: {
                    consignee: '',
                    mobile: '',
                    tel: '',
                    province: '',
                    city: '',
                    district: '',
                    address: '',
                    goods_attr: [],
                    goods_number: [],
                    goods_price: [],
                    contract_number: '',
                    session_id: localStorage.getItem('shouhou_session_id'),
                    staff_name: '',
                    store_name: '',
                    postscript: '',
                    order_sn: '',
                    method_type: '10',
                    agency:'（电商）广州艾巢环境设备有限公司',
                    agency_id:61,
                },
                agencyList:[{label:'（电商）广州艾巢环境设备有限公司',value:61},{label:'广州亿星商场部',value:62},{label:'广州亿星人居环境设备有限公司',value:40},{label:'广州艾巢环境科技有限公司',value:39},],
                yuyueForm: {
                    install_id: '',
                    delivery_method: '',
                    order_sn: '',
                    company_id: '',
                    company_name: '',
                    siji_id: '',
                    siji_name: '',
                    wuliu_id: '',
                    wuliu_name: '',
                    wuliu_pay: '',
                },
                formData: {//填写配送信息
                    goodsSelect: '', //配送方式
                    wuliu_pay: '01',
                    azTime: new Date(),
                    yytime: '', //安装时间
                    company_id: '',
                    company_name: '',
                    siji_id: '',
                    siji_name: '',
                    wuliu_id: '',
                    wuliu_name: '',
                    kuaidi_id: '',
                    kuaidi_name: '',
                    province: '2', //省
                    city: '', //市
                    district: '', //区
                    address: '', //详细地址
                    remark: '',
                },
                selectCompany: [],
                selectWuliu: [],
                selectKuaidi: [],
                selectSonghuo: [],
                page: 1,
                pickerOptions0: {//限制安装时间只能是当天或之后
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    }
                },
                ispuguan: false,
                referer: '',
                departmentList: [],
                restaurant1: [],
                cityList:[],
                districtList:[]
            }
        },
        created() {
            this.formData.yytime = Date.parse(new Date().toLocaleDateString()).toString().slice(0, 10)
            this.getShopAttr()
        },
        methods: {
            handlePageChange(val) { //分页
                this.getOrderList({page: val});
            },
            //搜索订单
            searchOrder () {
                // console.log('ss')
                this.$emit('update:ddly', this.ddly);
                this.$emit('update:psfs', this.psfs);
                this.$emit('update:ddzt', this.ddzt);
              this.getOrderList()
            },
            //添加安装单
            addOrder () {
                this.ShowAddOrder = true
                this.$http.get(this.$reqUrl + `service.php?act=department`).then(res => {
                    this.departmentList = res.data
                    // console.log(res.data);
                    // this.formData.store_name = res.data.data[0].department_name
                })
            },
            InpurtOrder () {
                this.isbtnload = true
                this.$http.post(this.$reqUrl + `service.php?act=insert_k3_order&DDDH=${this.inputForm.DDDH}&k3address=${this.k3url}&session_id=${localStorage.getItem('shouhou_session_id')}`).then(res => {
                    if (res.data.error === 0) {
                        this.isbtnload = false
                        this.$message.success(res.data.msg)
                        this.getOrderList()
                        this.ShowInputOrder = false
                    } else if (res.data.error === 1) {
                        this.isbtnload = false
                        this.$message.error(res.data.msg)
                    }
                })
            },
            addGoods () {
                var data = {}
                data.goods = ''
                data.number = ''
                data.price = ''
                this.goodsList.push(data)
            },
            delGoods(index) {
                if (this.goodsList.length > 1) {
                    this.goodsList.splice(index, 1)
                } else {
                    this.$message.error('最少输入一个商品')
                }
            },
            qrAdd () {
                this.isbtnload = false
                this.addForm.province = this.formData.province
                this.addForm.city = this.formData.city
                this.addForm.district = this.formData.district
                this.addForm.address = this.formData.address
                this.goodsList.forEach((item, i) => {
                    this.addForm.goods_attr.push(item.goods)
                    this.addForm.goods_number.push(item.number)
                    this.addForm.goods_price.push(Number(0))
                })
                if (this.addForm.store_name === '') {
                   this.$message.error('部门不能为空')
                } else {
                    this.isbtnload = true
                    this.addForm.agency=this.addForm.agency_id==61?'（电商）广州艾巢环境设备有限公司':this.addForm.agency_id==62?'广州亿星商场部':this.addForm.agency_id==40?'广州亿星人居环境设备有限公司':'广州艾巢环境科技有限公司'
                    this.$http.post(this.$reqUrl + `service.php?act=order_add`, qs.stringify(this.addForm)).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success(res.data.msg)
                            this.ShowAddOrder = false
                            this.isbtnload = false
                            this.goodsList = [{goods: '', number: '', price: ''}]
                            this.addForm.goods_attr = []
                            this.addForm.goods_number = []
                            this.addForm.goods_price = []
                        }
                        else if(res.data.error === 1){
                            this.isbtnload = false
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            },
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            OrderAdd(row) { //弹出框数据赋值
                this.fpload = true
                this.changeAddress = false
                this.formData.remark = row.postscript
                this.referer = row.referer
                if (row.install.status === '8') {
                    this.formData.azTime = new Date(+row.install.yuyue_time * 1000)
                    this.formData.yytime = Date.parse(this.formData.azTime.toLocaleDateString()).toString().slice(0, 10)
                    // console.log(this.formData.azTime)
                    // console.log(this.yytime)
                } else {
                    this.formData.azTime = new Date()
                    this.formData.yytime = Date.parse(new Date().toLocaleDateString()).toString().slice(0, 10)
                    // console.log(this.formData.azTime)
                }
                this.OrderFenpei = []
                    row.goods_list.forEach((item, i) => {
                        item.fpnum = item.goods_number-item.yuyue_number
                        if (+item.goods_number - +item.yuyue_number !== 0) {
                            this.OrderFenpei.push(item)
                        }
                })
                let order_id = row.order_id
                let goods_attr = []
                this.OrderFenpei.forEach(item => {
                    if (item.goods_attr_select.length === 0) {
                        goods_attr.push(item.goods_attr.replace(/\s+/g, ""))
                    } else {
                        goods_attr.push(item.goods_attr_select[0].replace(/\s+/g, ""))
                    }
                })
                let attr = {order_id: order_id, goods_attr: goods_attr}
                this.$http.get(this.$reqUrl + `service.php?act=check_storges&goods_attr=${JSON.stringify(attr)}`).then(res => {
                    if (res.data.error === 0) {
                        res.data.data.forEach((item, i) => {
                            this.OrderFenpei[i].keyongNum = item
                        })
                        this.OrderFenpei.forEach((item, i) => {
                            if (item.keyongNum !== 0 && item.keyongNum >= (item.goods_number - item.yuyue_number)) {
                                this.OrderFenpei[i].fpnum = item.goods_number - item.yuyue_number
                            } else if (item.keyongNum !== 0 && item.keyongNum < (item.goods_number - item.yuyue_number)){
                                this.OrderFenpei[i].fpnum = item.keyongNum
                            }
                        })
                            this.ShowDistribution = true
                    }
                })
                this.form = row
                if (row.install.delivery_method === '9') { //判断是否是铺管
                    this.formData.goodsSelect = 3
                    this.formData.company_id = row.install.company_id
                    this.formData.company_name = row.install.company_name
                    getInstallCompany(this.page).then(res => {
                        this.selectCompany = []
                        this.selectCompany = res.data.company_list
                        this.page_count = res.data.page_count
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                getInstallCompany(this.page).then(res => {
                                    res.data.company_list.forEach(item => {
                                        this.selectCompany.push(item)
                                    })
                                })
                            }
                            // console.log(this.selectCompany)
                        }
                    })
                    this.ispuguan = true
                    // this.isSongZhuang()
                } else if (row.install.status === '8') {
                    this.formData.goodsSelect = 3
                    this.isSongZhuang()
                } else {
                    this.formData.goodsSelect = ''
                    this.formData.company_id = ''
                    this.formData.company_name = ''
                    this.ispuguan = false
                }
                this.formData.address = this.form.address
                // console.log(this.form)
                this.form['time'] = ''
            },
            //预约订单分配
            OrderAnpai (row) {
                this.form=row
                this.ShowXiapai = true

                // this.getInstallCompanyList()
            },
            //确认预约
            OrderYuyue () {
                // console.log(this.formData)
                let datas = {
                    install_id: this.form.install.install_id,
                    order_sn: this.form.order_sn,
                    company_id: this.formData.company_id,
                    company_name: this.formData.company_name,
                    wuliu_id: this.formData.wuliu_id,
                    wuliu_name: this.formData.wuliu_name,
                    siji_id: this.formData.siji_id,
                    siji_name: this.formData.siji_name,
                    wuliu_pay: this.formData.wuliu_pay,
                    delivery_method: this.formData.goodsSelect,
                }
                this.$http.post(this.$reqUrl + `service.php?act=post_yuyue_fenpei&session_id=${localStorage.getItem('shouhou_session_id')}`, qs.stringify(datas)).then(res => {
                    if (res.data.error === 0) {
                        this.$message.success(res.data.msg)
                        this.getOrderList({page: this.page})
                        this.ShowXiapai = false
                    }
                })
                // console.log(datas);
            },
            //关闭订单
            CloseOrder(row) {
                this.$confirm('确定关闭该分配订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.post(`${this.$reqUrl}user.php?act=order_update_tax&type=close&order_id=${row.order_id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('操作成功!')
                            this.getOrderList()
                        } else if (res.data.error === 1) {
                            this.$message.error('操作失败')
                        }
                    })
                })
            },
            //取消关闭
            QrOrder(row) {
                this.$confirm('确定开启该分配订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'success'
                }).then(() => {
                    this.$http.post(`${this.$reqUrl}user.php?act=order_update_tax&type=start&order_id=${row.order_id}`).then(res => {
                        if (res.data.error === 0) {
                            this.$message.success('操作成功!')
                            this.getOrderList()
                        } else if (res.data.error === 1) {
                            this.$message.error('操作失败')
                        }
                    })
                })
            },
            OrderDetail(row) { //弹出框数据赋值
                this.ShowDetail = true
                this.OrderFenpei = []
                row.goods_list.forEach((item, i) => {
                        this.OrderFenpei.push(item)
                    // this.OrderFenpei[i]['max'] = +item.goods_number - +item.yuyue_number
                    // this.OrderFenpei[i]['fpnum'] = +item.goods_number - +item.yuyue_number
                    // if (+item.goods_number - +item.yuyue_number === 0) {}
                })
                // this.OrderFenpei.forEach((item, i) => {
                //     console.log(this.orderFenpei[i].goods_number);
                //     // if (+item.goods_number-+item.yuyue_number ===0){
                //     //     item
                //     // }
                // })
                // console.log(this.OrderFenpei)
                this.form = row
                this.form['time'] = ''
            },
            handleChange() {
              // console.log(this.OrderFenpei)
            },
            getInstallCompanyList () {
                getInstallCompany(this.page).then(res => {
                    this.selectCompany = []
                    this.selectCompany = res.data.company_list
                    this.page_count = res.data.page_count
                    if (this.page_count > 1) {
                        this.page = 2;
                        for (var i = 0; i < this.page_count - 1; i++) {
                            this.page += i;
                            getInstallCompany(this.page).then(res => {
                                res.data.company_list.forEach(item => {
                                    this.selectCompany.push(item)
                                })
                            })
                        }
                        // console.log(this.selectCompany)
                    }
                })
            },
            //判断配送方式
            isSongZhuang() {
              if (this.formData.goodsSelect !== 3 && this.formData.goodsSelect !== 10) { //非送装
                  // this.formData.azTime = ''
                  this.formData.company_id = ''
                  this.formData.company_name = ''
              } else if (this.formData.goodsSelect === 3 || this.formData.goodsSelect === 10) { //送装
                  this.page = 1;
                  getInstallCompany(this.page).then(res => {
                      this.selectCompany = []
                      this.selectCompany = res.data.company_list
                      this.page_count = res.data.page_count
                      if (this.page_count > 1) {
                          this.page = 2;
                          for (var i = 0; i < this.page_count - 1; i++) {
                              this.page += i;
                              getInstallCompany(this.page).then(res => {
                                  res.data.company_list.forEach(item => {
                                      this.selectCompany.push(item)
                                  })
                              })
                          }
                          // console.log(this.selectCompany)
                      }
                  })
              }
                if (this.formData.goodsSelect !== 9) { //非送装
                    // this.formData.azTime = ''
                    this.formData.company_id = ''
                    this.formData.company_name = ''
                } else if (this.formData.goodsSelect === 9) { //送装
                    this.page = 1;
                    // console.log(this.form.install.company_id)
                    this.formData.company_id = this.form.install.company_id
                    this.formData.company_name = this.form.install.company_name
                    getInstallCompany(this.page).then(res => {
                        this.selectCompany = []
                        this.selectCompany = res.data.company_list
                        this.page_count = res.data.page_count
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                getInstallCompany(this.page).then(res => {
                                    res.data.company_list.forEach(item => {
                                        this.selectCompany.push(item)
                                    })
                                })
                            }
                            // console.log(this.selectCompany)
                        }
                    })
                }
              if (this.formData.goodsSelect !== 1) {
                  this.formData.wuliu_id = ''
                  this.formData.wuliu_name = ''
                  this.formData.wuliu_pay = ''
              } else if (this.formData.goodsSelect === 1) {
                  this.page = 1;
                  this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                      this.selectWuliu = []
                      this.selectWuliu = res.data.data
                      this.page_count = res.data.page_count
                      // console.log(this.selectWuliu)
                      if (this.page_count > 1) {
                          this.page = 2;
                          for (var i = 0; i < this.page_count - 1; i++) {
                              this.page += i;
                              this.$http.get(this.$reqUrl + `service.php?act=wuliu_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                  res.data.data.forEach(item => {
                                      this.selectWuliu.push(item)
                                  })
                              })
                          }
                      }
                  })
              }
                if (this.formData.goodsSelect !== 4) {
                    this.formData.kuaidi_id = ''
                    this.formData.kuaidi_name = ''
                } else if (this.formData.goodsSelect === 4) {
                    this.page = 1;
                    this.$http.get(this.$reqUrl + `service.php?act=kuaidi_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                        this.selectKuaidi = []
                        this.selectKuaidi = res.data.data
                        this.page_count = res.data.page_count
                        // console.log(this.selectKuaidi)
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                this.$http.get(this.$reqUrl + `service.php?act=kuaidi_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                    res.data.data.forEach(item => {
                                        this.selectKuaidi.push(item)
                                    })
                                })
                            }
                        }
                    })
                }
                if (this.formData.goodsSelect !== 0) {
                    this.formData.siji_name = ''
                    this.formData.siji_id = ''
                } else if (this.formData.goodsSelect === 0) {
                    this.page = 1;
                    this.$http.get(this.$reqUrl + `service.php?act=siji_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                        this.selectSonghuo = []
                        this.selectSonghuo = res.data.data
                        this.page_count = res.data.page_count
                        // console.log(this.selectSonghuo)
                        if (this.page_count > 1) {
                            this.page = 2;
                            for (var i = 0; i < this.page_count - 1; i++) {
                                this.page += i;
                                this.$http.get(this.$reqUrl + `service.php?act=siji_list&session_id=${localStorage.getItem('shouhou_session_id')}&page=${this.page}`).then(res => {
                                    res.data.data.forEach(item => {
                                        this.selectSonghuo.push(item)
                                    })
                                })
                            }
                        }
                    })
                }
            },
            selectname(id) { //根据所选安装公司id判断安装公司
                this.selectCompany.forEach((item, i) => {
                    if (id === item.company_id) {
                        this.formData.company_name = item.company_name
                    }
                })
                // console.log(this.formData)
            },
            selectwuliuu(id) { //根据所选物流公司id判断物流公司
                this.selectWuliu.forEach((item, i) => {
                    // console.log(id, item.id)
                    if (id === item.id) {
                        this.formData.wuliu_name = item.name
                    }
                })
                // console.log(this.formData.wuliu_name)
            },
            selectkuaidi(id) { //根据所选物流公司id判断物流公司
                this.selectKuaidi.forEach((item, i) => {
                    if (id === item.id) {
                        this.formData.kuaidi_name = item.name
                    }
                })
            },
            selectsiji(id) { //根据所选司机id判断司机名
                this.selectSonghuo.forEach((item, i) => {
                    // console.log(item.id)
                    if (id === item.id) {
                        this.formData.siji_name = item.siji_name
                    }
                })
                // console.log(this.formData.siji_name)
            },
            consl () { //日期转时间戳
                this.formData.yytime = Date.parse(this.formData.azTime.toLocaleDateString()).toString().slice(0, 10)
                // console.log(this.formData.yytime)
            },
            handleSelectionChange(val) {
                if (this.referer === 'k3导入' || this.referer === '管理员添加') {
                    this.OrderSelect = val
                } else {
                    let select = []
                    let noselect = []
                    val.forEach((item, i) => {
                        if(item.relateCan ==true){
                            select.push(item)
                        }else{
                            if (item.keyongNum !== 0) {
                                select.push(item)
                            // this.OrderSelect.splice(i,1)
                            } else if (item.keyongNum === 0) {
                                noselect.push(item)
                                this.$message.error(item.goods_attr_select[0]+'库存不足,无法分配')
                            }
                        }
                        
                    })
                    this.OrderSelect = select;
                    this.toggleSelection(noselect)
                }
            },
            /*handleSelectionChange(val) {
                if (this.referer === 'k3导入' || this.referer === '管理员添加') {
                    this.OrderSelect = val
                } else {
                    let select = []
                    let noselect = []
                    val.forEach((item, i) => {
                        if (item.keyongNum !== 0) {
                            select.push(item)
                            // this.OrderSelect.splice(i,1)
                        } else if (item.keyongNum === 0) {
                            noselect.push(item)
                            this.$message.error(item.goods_attr_select[0]+'库存不足,无法分配')
                        }
                        
                        
                    })
                    this.OrderSelect = select;
                    this.toggleSelection(noselect)
                }
            },*/
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                }
            },
            isChangeAddr() { //修改地址
                this.changeAddress = true;
            },
            // SureChangeAddr() { //确认修改
            //     this.changeAddress = false
            // },
            FalseChangeAddr() { //取消修改
                this.changeAddress = false
                this.formData.province = this.form.province
                this.formData.city = this.form.city
                this.formData.district = this.form.district
                this.formData.address = this.form.address
                // console.log(this.formData);
            },

            //获取商品型号
            getShopAttr () {
                this.$http.get(this.$reqUrl + `supply.php?step=goods_model`).then(res => {
                    this.restaurant1 = []
                    if (res.data.length !== 0) {
                        res.data.forEach((item, index) => {
                            this.restaurant1.push({value: item.attr_value, goods_id: item.goods_id, goods_attr_id: item.goods_attr_id})
                        })
                    }
                    // console.log(this.restaurant1.length)
                })
            },
            //选择型号
            querySearch2(queryString, cb) {
                var restaurant1 = this.restaurant1;
                var results = queryString ? restaurant1.filter(this.createFilter2(queryString)) : restaurant1;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter2(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleSelect2(item) {
            },
            //提交分配
            queren() {
                this.isbtnload = false
                if (this.OrderSelect.length === 0) {
                    this.$message.error('请选择配送商品')
                } else {
                    this.isbtnload = true
                    let rec_ids = []
                    let numbers = []
                    if (this.changeAddress === false) {
                        this.formData.province = this.form.province
                        this.formData.city = this.form.city
                        this.formData.district = this.form.district
                        this.formData.address = this.form.address
                    }
                    this.OrderSelect.forEach(item => {
                        rec_ids.push(item.rec_id)
                        numbers.push(item.fpnum)
                    })
                    var datas = {
                        city_checked_id: this.formData.city,
                        district_checked_id: this.formData.district,
                        province_checked_id: this.formData.province,
                        address: this.formData.address,
                        mobile: this.form.mobile,
                        tel: this.form.tel,
                        consignee: this.form.consignee,
                        order_sn: this.form.order_sn,
                        yuyue_time: this.formData.yytime,
                        rec_ids: rec_ids, //rec_id数组
                        numbers: numbers, //商品数量数组
                        delivery_method: this.formData.goodsSelect,
                        order_id: this.form.order_id,
                        company_id: this.formData.company_id,
                        company_name: this.formData.company_name,
                        wuliu_id: this.formData.wuliu_id,
                        wuliu_name: this.formData.wuliu_name,
                        siji_id: this.formData.siji_id,
                        siji_name: this.formData.siji_name,
                        kuaidi_id: this.formData.kuaidi_id,
                        kuaidi_name: this.formData.kuaidi_name,
                        remark: this.formData.remark,
                        wuliu_pay: this.formData.wuliu_pay
                    }
                    // console.log(datas)
                    // this.$http.post(this.$reqUrl + `user.php?act=post_orders_yuyue&session_id=${session_id}`, qs.stringify(datas)).then(res => {
                    //     // if (res.data.error === 0) {
                    //     this.$message.success(res.data.msg)
                    //     // this.getOrderList()
                    //     this.ShowDistribution = false
                    //     // }
                    // })
                    postAppointment(datas).then(res => {
                        if (res.data.error === 0) {
                            this.isbtnload = false
                            this.$message.success(res.data.content)
                            this.getOrderList({page: this.page})
                            this.ShowDistribution = false
                        } else if (res.data.error === 1) {
                            this.isbtnload = false
                            this.$message.error(res.data.content)
                        }
                    })
                }
                }

        },
        watch: {
            'formData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1) {
                        this.getCityList(this.formData.province);
                        this.getDistrictList(this.formData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.formData.province = this.provinceList[0].region_id;
                        this.formData.city = provinces[0].region_id;
                        this.formData.district = districts[0].region_id;
                    }
                }
            },
            editData (val) {
                if (this.type === 3) {
                    const {province_checked_id, city_checked_id, district_checked_id, ...rest} = val;
                    this.formData = {
                        province: province_checked_id,
                        city: city_checked_id,
                        district: district_checked_id,
                        ...rest
                    };
                } else {
                    this.formData = {...val};
                }
            }
        },
        computed: {
            ...mapState(['provinceList']),
        }
    }
</script>
<style lang="less" scoped>
    .el-table td, .el-table th{
        padding: 0;
    }
    .ddzt{
        background: #09bb07;
    }
    .wrapper{
        .bar {
            display: flex;
            justify-content: space-between;
            margin-bottom: 15px;
            .btnGroup {
                button {
                    width: 100Px;
                    height: 35Px;
                    margin-right: 10Px;
                    font-size: 16px;
                    color: #ffffff;
                    background: #f56c31;
                    border-radius: 2px;
                }
            }
        }
    }
    .dialog-left{
        width:55%;
        margin-top: 20px;
        margin-bottom: 40px;
        margin-left: 15px;
        height: auto;
        text-align: center;
        border: 1px solid #f56c31;
        float: left;
    }
    .dialog-right{
        width:36% ;
        margin-top: 20px;
        margin-right: 15px;
        float: right;
        text-align: center;
    }

</style>
<style>
    .el-table td, .el-table th{
        padding: 0;
        height: 50px;
        line-height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/components/OrderControl/OrderList.vue